module.exports = __webpack_public_path__ + "static/empty-tile-93747987adb35399092c33659e33ec37.png";